<template>
  <div class="select-dataset-dailog dialog col-block">
    <div class="description-container">
      <div class="description">{{ 'Different upload data formats will charge different points, please choose the format before creating a case.'/* ___ */ }}</div>
    </div>
    <div :style="{ height: '10px' }"></div>
    <hr class="no-margin">
    <div class="select-container row-block stretch">
      <div :style="{ width: '10px' }"></div>
      <div class="vcf-container select-block col-block" :class="{ hover: hover['vcf'] }" :style="{ flex: 1 }" @mouseover="e => hover['vcf'] = true" @mouseleave="e => hover['vcf'] = false">
        <div class="select-title">{{ 'VCF' }}</div>
        <div class="select-description" v-html="'<b>' + priceMap['vcf'].price + '</b> points/case'/* ___ */"></div>
        <div :style="{ height: '20px' }"></div>
        <button class="circle-button" :class="['white-gray-button']" @click="e => $emit('changeModal', {}, 'vcf')">
          <span>{{ 'VCF'/* ___ */ }}</span>
        </button>
        <div :style="{ height: '20px' }"></div>
      </div>
      <div class="fastq-container select-block col-block" :class="{ hover: hover['fastq'] }" :style="{ flex: 1 }" @mouseover="e => hover['fastq'] = true" @mouseleave="e => hover['fastq'] = false">
        <div class="select-title">{{ 'FASTQ' }}</div>
        <div class="select-description" v-html="'<b>' + priceMap['fastq'].price + '</b> points/case'/* ___ */"></div>
        <div :style="{ height: '20px' }"></div>
        <button class="circle-button" :class="['main-button']" @click="e => $emit('changeModal', {}, 'fastq')">
          <span>{{ 'fastq'/* ___ */ }}</span>
        </button>
        <div :style="{ height: '20px' }"></div>
      </div>
      <div :style="{ width: '10px' }"></div>
    </div>
  </div>
</template>

<script>
import { priceMap } from '../../constants/global/data'

export default {
  computed: {
    // global
    priceMap () { return priceMap }
  },
  data () {
    return {
      hover: {
        vcf: false,
        fastq: false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/selectDataset.vue